import {Box, Button, ButtonGroup, Flex, useToken} from '@chakra-ui/react';
import React from 'react';
import {atom, useRecoilState} from 'recoil';
import {CloseIcon} from '@chakra-ui/icons';
import MenuKit from '../../../components/kits/Menu';
import _ from 'lodash';
import {useNavigate} from 'react-router-dom';
import Container from "../../../components/Container";

const initialTeamFilterState = {
    location: null,
    team: null,
    iden: null,
};

const teamOrder = atom({
    key: 'Team-nav__order',
    default: initialTeamFilterState,
});

const TeamNav = ({data: TEAM, slug, categoriesData}) => {
    const [filter, setFilter] = useRecoilState(teamOrder);
    const [openFilter, setOpenFilter] = React.useState(false);
    const brand700 = useToken('color', ['brand.700']);
    const navigate = useNavigate();

    // const teamsSlug = _.flattenDeep(TEAM.map((item) => item.teams));
    const teamsOffice = TEAM.length ? TEAM?.map((item) => item.office) : null;

    const teamDropdown = categoriesData?.map((item, index)=>{
        return {
            ...item,
            title: item.name,
            value: item.slug,
            onClick: () => {
                setFilter({
                    ...filter,
                    team: index,
                    iden: item.slug,
                });
                navigate(`/team/${item.slug}`);
            },
            key: item.slug,
            index,
        }
    })
    // const teamDropdown = _.uniqBy(teamsSlug, 'name').reduce((acc, item, key) => {
    //     let index = null;
    //     if (item.name === 'Technology') {
    //         index = 0;
    //     }
    //     if (item.name === 'Public Healthcare') {
    //         index = 1;
    //     }
    //     if (item.name === 'Private Healthcare') {
    //         index = 2;
    //     }
    //     if (item.name === 'Portfolio Advisory Committee') {
    //         index = 3;
    //     }
    //     if (item.name === 'Venture Development') {
    //         index = 4;
    //     }
    //     if (item.name === 'Operations') {
    //         index = 5;
    //     }
    //     acc.push({
    //         ...item,
    //         title: item.name,
    //         value: key,
    //         onClick: () => {
    //             setFilter({
    //                 ...filter,
    //                 team: index,
    //                 iden: key,
    //             });
    //             navigate(`/team/${item.slug}`);
    //         },
    //         key,
    //         index,
    //     });
    //     return acc.sort((a, b) => {
    //         return a.index - b.index;
    //     });
    // }, []);

    React.useLayoutEffect(() => {
        const filteredTeam = teamDropdown?.find((fid) => {
            return fid.slug === slug;
        });
        if (filteredTeam) {
            setFilter({...filter, team: filteredTeam.index, iden: filteredTeam.key});
        }
        // slug
    }, [setFilter, slug]);

    const teamLocationDropdown = _.uniqBy(teamsOffice)
        .reduce((acc, item, key) => {
            acc.push({
                title: item,
                value: item,
                onClick: () =>
                    setFilter({
                        ...filter,
                        location: item,
                    }),
            });
            return acc;
        }, [])
        .filter((fid) => fid.title !== 'None');

    const isAll = Object.values(filter).filter((fid) => fid !== null).length === 0;

    const teamMenu = (
        <MenuKit
            gutter={20}
            buttonProps={{
                children:
                    typeof filter.team === 'number' ? teamDropdown[filter.team].title : 'Team',
                isActive: typeof filter.team === 'number',
            }}
            activeItem={filter.iden}
            options={teamDropdown}
        />
    );

    const locationMenu = (
        <MenuKit
            gutter={20}
            buttonProps={{
                children: filter.location || 'Location',
                isActive: !!filter.location,
            }}
            activeItem={filter.location}
            options={teamLocationDropdown}
        />
    );
    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'}>
                <Box position={'relative'}>
                    <Container>
                        <Box pb={'42px'} pt={['42px', 0]} as="section">
                            <Box as="nav">
                                
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </Box>
        </>
    );
};

export default TeamNav;
export {teamOrder};
